import createComponent from '@carvana/merch-components/createComponent';

export const Container = createComponent('div', {
  className: 'flex flex-col gap-2xl rounded-md bg-background-default'
});

export const QuestionButton = createComponent('button', () => ({
  className:
    'min-h-36 max-w-fit overflow-hidden whitespace-normal break-words rounded-full bg-background-primary-subtle active:bg-background-primary-weak disabled:bg-disabled px-xl py-md text-left text-text-primary t-body-sm hover:text-text-primary-hover active:text-text-primary-active'
}));
